var _defs, _rect, _g, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterFiltrationLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    id: "svg16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "use2",
    points: "844.08792,0.24557334 0,0.24557334 0,293.8709 844.08792,293.8709 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "use1",
    points: "844.08792,0.24557334 0,0.24557334 0,293.8709 844.08792,293.8709 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "use3",
    points: "844.08792,0.24557334 0,0.24557334 0,293.8709 844.08792,293.8709 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "use4",
    points: "844.08792,0.24557334 0,0.24557334 0,293.8709 844.08792,293.8709 "
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#fff",
    id: "rect1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(0.05081909,0,0,0.04829484,192.34192,142.89508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 24.370931,71.282216 c 21.248362,19.707515 55.261243,19.683488 75.792999,-0.04462 26.81066,-25.47063 70.43397,-25.465481 97.29114,0.04462 21.24319,19.707515 55.25435,19.683488 75.79128,-0.04462 0.0517,-0.05149 0.11024,-0.09783 0.16192,-0.147597 C 247.55193,28.652679 200.72458,0.24557334 147.3582,0.24557334 c -52.668715,0 -98.941393,27.69315166 -125.002719,69.20885266 0.678707,0.598966 1.357414,1.196216 2.01545,1.82779",
    id: "Fill-40",
    fill: "#1381b2",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.32304,82.830754 C 166.07468,63.123239 132.06179,63.148983 111.53176,82.875376 98.762073,95.019448 80.919306,101.98564 62.578706,101.98564 45.006389,101.98564 27.971525,95.445074 14.485233,83.616789 8.0099517,97.027442 3.5570118,111.57939 1.4313144,126.85731 c 8.3494777,3.18704 16.1804506,7.99078 22.9416846,14.4095 21.248361,19.71438 55.25952,19.68348 75.791281,-0.0378 26.80549,-25.47063 70.43396,-25.47063 97.28596,0.0378 21.24837,19.71438 55.25436,19.68863 75.79817,-0.0378 6.00329,-5.70476 12.86616,-10.12921 20.18207,-13.27679 -1.95171,-14.84714 -6.12042,-28.992338 -12.18228,-42.107799 -26.9812,22.444909 -68.16529,21.459789 -93.92516,-3.013707",
    id: "Fill-37",
    fill: "#1381b2",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 294.67472,145.38611 c -3.58647,2.06635 -6.99206,4.52743 -10.06175,7.48106 -26.81238,25.46377 -70.43397,25.46377 -97.29286,-0.0446 -21.24836,-19.71438 -55.25952,-19.68349 -75.79128,0.0446 -12.769686,12.14408 -30.612452,19.10341 -48.953052,19.10341 -17.959904,0 -35.375464,-6.81174 -48.997843,-19.14803 -4.0843016,-3.78601 -8.6474884,-6.83061 -13.4880149,-9.16125 -0.03100693,1.13271 -0.0895755785,2.26028 -0.0895755785,3.39986 0,19.03646 3.6967152785,37.22683 10.3459794785,53.93437 5.01451,2.77515 9.732731,6.18702 14.023746,10.26307 21.248361,19.71438 55.261243,19.68349 75.79128,-0.0395 26.81238,-25.47578 70.43396,-25.46891 97.29286,0.0395 21.24147,19.70752 55.24746,19.68349 75.79127,-0.0395 3.19199,-3.03773 6.63721,-5.70476 10.24952,-8.00966 7.21772,-17.30651 11.22451,-36.26574 11.22451,-56.14831 0,-0.56121 -0.0379,-1.11556 -0.0448,-1.67505",
    id: "Fill-38",
    fill: "#1381b2",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 187.32304,222.80937 c -21.24836,-19.70751 -55.26125,-19.68348 -75.79128,0.0446 -12.769687,12.14407 -30.612454,19.10855 -48.953054,19.10855 -12.090981,-0.005 -23.918402,-3.10124 -34.515883,-8.87122 26.798602,36.7892 70.278934,60.77871 119.295727,60.77871 47.65421,0.007 90.06824,-22.66287 117.01671,-57.72209 -25.32749,10.87577 -56.22418,6.43931 -77.05222,-13.33858",
    id: "Fill-39",
    fill: "#1381b2",
    mask: "url(#mask-4)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 50,
    fill: "none",
    stroke: "#2f92d0",
    strokeWidth: 2,
    id: "circle1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;80",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 30,
    fill: "none",
    stroke: "#2f92d0",
    strokeWidth: 2,
    id: "circle2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;80",
    dur: "3s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0",
    dur: "3s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 10,
    fill: "none",
    stroke: "#2f92d0",
    strokeWidth: 2,
    id: "circle3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;80",
    dur: "3s",
    begin: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0",
    dur: "3s",
    begin: "1s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFiltrationLoading);
export default __webpack_public_path__ + "static/media/water-filtration-loading.2feb1fa60f106cdf072f37e51d707f4a.svg";
export { ForwardRef as ReactComponent };